// extracted by mini-css-extract-plugin
export default {"root":"_1P_e4","link-overlay":"_1fme1","linkOverlay":"_1fme1"};